import { render, staticRenderFns } from "./ReevaluationDetail.vue?vue&type=template&id=24b9746e&scoped=true&lang=pug"
import script from "./ReevaluationDetail.vue?vue&type=script&lang=ts"
export * from "./ReevaluationDetail.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ReevaluationDetail.vue?vue&type=style&index=0&id=24b9746e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "24b9746e",
  null
  ,true
)

export default component.exports